import {animate, style, transition, trigger} from '@angular/animations';

export class AppearDisappearAnimations {
  private static widthOpacityTriggerConfig(title, time) {
    return trigger(title, [
      transition('void => *', [
        style({
          'opacity': '0',
          'width': '0',
          'padding-left': '0',
          'padding-right': '0'
        }),
        animate(time)
      ]),
      transition('* => void', [
        style({
          'opacity': '1',
          'width': '*',
          'padding-left': '*',
          'padding-right': '*'
        }),
        animate(time,
          style({
            'opacity': '0',
            'width': '0',
            'padding-left': '0',
            'padding-right': '0'
          })
        )
      ])
    ]);
  }
  private static opacityTranslatePaddingTriggerConfig(title, time) {
    return trigger(title, [
      transition('void => *', [
        style({
          'opacity': '0',
          'transform': 'translateY(-100%)',
          'height': '0',
          'padding': '0'
        }),
        animate(time,
          style({
            'opacity': '1',
            'transform': 'translateY(0)',
            'height': '*',
            'padding': '1rem'
          })
        )
      ]),
      transition('* => void', [
        style({
          'opacity': '1',
          'transform': 'translateY(0)',
          'height': '*',
          'padding': '1rem'
        }),
        animate(time,
          style({
            'opacity': '0',
            'transform': 'translateY(-100%)',
            'height': '0',
            'padding': '0'
          })
        )
      ])
    ]);
  }
  private static heightOpacityTriggerConfig(title, time) {
    return trigger(title, [
      transition('void => *', [
        style({
          'opacity': '0',
          'height': '0',
        }),
        animate(time,
          style({
            'opacity': '1',
            'height': '*',
          })
        )
      ]),
      transition('* => void', [
        style({
          'opacity': '1',
          'height': '*',
        }),
        animate(time,
          style({
            'opacity': '0',
            'height': '0',
          })
        )
      ])
    ]);
  }

  static widthOpacityTrigger() {
    return AppearDisappearAnimations.widthOpacityTriggerConfig('widthOpacity', 300);
  }

  static widthOpacityFasterTrigger() {
    return AppearDisappearAnimations.widthOpacityTriggerConfig('widthOpacityFaster', 200);
  }

  static opacityTranslatePaddingTrigger() {
    return AppearDisappearAnimations.opacityTranslatePaddingTriggerConfig('opacityTranslatePadding', 300);
  }
  static heightOpacityTrigger() {
    return AppearDisappearAnimations.heightOpacityTriggerConfig('heightOpacity', 200);
  }
}
